import axios from '@/utils/axios'
import {AddressValues} from '@/forms/Address'

export const GetReviews = async ({queryKey}: any) => {
  const {data} = await axios.get(
    process.env.NEXT_PUBLIC_API_URL + '/review/' + queryKey[1],
  )

  return data
}

export const ReviewPost = async (post_data: any) => {
  const {data} = await axios.post(
    process.env.NEXT_PUBLIC_API_URL + '/review/' + post_data.id,
    post_data.data,
  )

  return data
}
export const ReviewDelete = async (id: number) => {
  const {data} = await axios.delete(
    process.env.NEXT_PUBLIC_API_URL + '/review/' + id,
  )

  return data
}

export const ReviewUpdate = async (post_data: any) => {
  const {data} = await axios.put(
    process.env.NEXT_PUBLIC_API_URL + '/review/' + post_data.id,
    post_data.data,
  )

  return data
}
